import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useManageIqWorkspacesStyles = makeStyles({
  nameCellStack: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  nameCell: {
    fontWeight: designTokens.fontWeight.semibold,
  },
  nameCellSub: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
  },
  pill: {
    background: projectIqTokens.tealSoft,
    color: projectIqTokens.tealInk,
    borderRadius: designTokens.borderRadius.lg,
    padding: "2px 8px",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
  },
});
